export default "__VITE_ASSET__CfhyMN9G__"